var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.82373 3.36037H5.32135V2.17967C5.32135 0.97778 4.27992 0 3 0C1.71999 0 0.678653 0.97778 0.678653 2.17967V3.36037H0.176274C0.0789706 3.36037 0 3.43452 0 3.52588V7.83449C0 7.92585 0.0789706 8 0.176274 8H5.82373C5.92103 8 6 7.92585 6 7.83449V3.52588C6 3.43444 5.92121 3.36037 5.82373 3.36037ZM2.61431 6.1406C2.49956 6.03981 2.43628 5.90301 2.43628 5.75529C2.43628 5.46348 2.68914 5.22597 3 5.22597C3.31077 5.22597 3.56372 5.4634 3.56372 5.75529C3.56372 5.90301 3.50053 6.03981 3.38569 6.1406C3.35008 6.17189 3.32981 6.21567 3.32981 6.26151V6.82277C3.32981 6.9935 3.18183 7.13245 2.99991 7.13245C2.818 7.13245 2.67002 6.9935 2.67002 6.82277V6.26151C2.6701 6.21567 2.64992 6.17189 2.61431 6.1406ZM3 1.17491C3.58999 1.17491 4.06998 1.62561 4.06998 2.17967V3.36037H1.93002V2.17967C1.93002 1.62569 2.41001 1.17491 3 1.17491Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6a9b7472e7708eeea46bf69166870b4a.svg";
export { ForwardRef as ReactComponent };